import { ITrangThaiHoc } from "../../../model/response/category/ITrangThaiHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTrangThaiHocActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ITrangThaiHoc[],
    LOAD_ERROR: "",
}
export const eTrangThaiHocActionIds = generateActionTypeIds(eTrangThaiHocActionsObj, "TRANG_THAI_HOC");
export type ITrangThaiHocActionTypes = IGenericActionType<typeof eTrangThaiHocActionsObj, "TRANG_THAI_HOC">;